import { GLOBAL_THEME_DEFAULT } from '_constants';
import { UI_ContactPerson } from 'ui/components/3-organisms/ContactPerson/ContactPerson';

// Contexts
import { useSiteContext } from 'application/contexts/SiteContext';

export const ContactPersonFeature: React.FC<Content.ContactPerson> = ({ content }) => {
	const { color } = content?.properties ?? {};
	const { properties } = content?.properties.include_ref_author ?? {};
	const SiteContext = useSiteContext();
	const globalTheme: string = SiteContext.settings.globalTheme?.setTheme ?? GLOBAL_THEME_DEFAULT;

	return (
		<UI_ContactPerson
			{...content?.properties}
			bgColor={color}
			image={{
				url: properties?.image?.url,
				altText: properties?.image?.properties?.altText,
				focalPoint: { top: properties?.image?.focalPoint?.top, left: properties?.image?.focalPoint?.left },
				fileType: properties?.image?.properties?.umbracoExtension,
			}}
			details={{
				name: properties.fullName,
				role: properties.workTitle,
				email: properties.email,
				phoneNumber: properties.phoneNumber,
				linkedIn: properties.linkedIn,
			}}
			globalTheme={globalTheme}
		/>
	);
};
